import React, { useMemo } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Text } from 'types';
import { TextLocation } from 'enums';
import { Loader } from 'components/loader/loader';
import { Jumbotron } from 'components/jumbotron/jumbotron';
import useFetch from 'utils/use-fetch';
import { parseHtml } from 'utils/parse-html';
import { GuideToc } from './guide-toc';
import { ScrollProvider } from 'components/scroll-provider/scroll-provider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toc: {
      padding: '0 25px',
      borderRight: '2px solid #eaeaea',
    },
    content: {
      padding: '50px 25px',
      '& ol, ul, li': {
        paddingLeft: '1.5em',
      },
      '& h1, h2, h3, h4': {
        fontWeight: 400,
        scrollMarginTop: '50px',
        paddingTop: 50,
        marginTop: -50,
      },
    },
    anchor: {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'none',
      },
    },
  })
);

export function Guide() {
  const classes = useStyles();

  const { data, loading } = useFetch<Text>(
    `/api/paragraph?location=${TextLocation.GUIDE}`
  );

  const htmlString = data?.text ?? '';

  const content = useMemo(() => parseHtml(htmlString, () => {}, classes), [
    htmlString,
    classes,
  ]);

  return (
    <ScrollProvider>
      <Grid container>
        <Grid item xs={12}>
          <Jumbotron title="Nápověda" />
          <Grid container id="guide">
            <Grid item xs={4} md={2} className={classes.toc}>
              <GuideToc content={content} />
            </Grid>
            <Grid item xs={8} md={8} className={classes.content}>
              {loading ? (
                <Loader />
              ) : (
                <Typography variant="body1" align="justify">
                  {content}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ScrollProvider>
  );
}
